export const TIMING_METRICS = {
  REPORT_DURATION: 'report.duration',
  REPORT_PHISHING_SUBMIT_DURATION: 'report.phishing.submit.duration',
  SBYC_DURATION: 'sbyc.duration',
} as const;
